import { KeyValueModel } from "model";

export const SituacaoFilialMock: KeyValueModel[] = [
    new KeyValueModel(true, "Ativado"),
    new KeyValueModel(false, "Desativado")
];